import { render, staticRenderFns } from "./TasksCalendarView.vue?vue&type=template&id=7196b418&scoped=true"
import script from "./TasksCalendarView.vue?vue&type=script&lang=js"
export * from "./TasksCalendarView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7196b418",
  null
  
)

export default component.exports